import { Link } from "react-router-dom";

export const LogoMark = ({ size = 34, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        className={className}
        data-testid="logo-mark"
        aria-hidden="true"
    >
        <line x1="13" y1="2.5" x2="13" y2="9" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="13" y1="39" x2="13" y2="45.5" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="9" y="9" width="8" height="30" fill="#D4AF37" />
        <path d="M17 12.5h9a8.5 8.5 0 0 1 0 17h-9" stroke="#D4AF37" strokeWidth="6.5" fill="none" />
        <path
            d="M20.5 24.5l3.5-3.5 3 3 5-5"
            stroke="#EBD98B"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const Logo = () => (
    <Link to="/" className="flex items-center gap-3" data-testid="logo">
        <LogoMark />
        <span className="font-display font-extrabold text-lg tracking-tight leading-none">
            pocket<span className="text-gold">folio</span>
            <span className="text-zinc-500 font-medium text-sm">.ai</span>
        </span>
    </Link>
);
